export const GENERAL_GLOBAL_REDUCER = "GENERAL_GLOBAL_REDUCER";
export const SEND_ALERT = "SEND_ALERT";
export const RESET_ALERT = "RESET_ALERT";
